// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LCt5snrqc3JTYO {\n  background-color: var(--ds-surface-raised, #ffffff);\n  border-radius: 8px;\n  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);\n  color: var(--ds-text, #172b4d);\n  cursor: pointer;\n  min-height: 20px;\n  position: relative;\n}\n.Y_mLqvFmzyAxzi {\n  display: flow-root;\n  position: relative;\n  padding: 8px 8px 4px 12px;\n  z-index: 10;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardFront": "LCt5snrqc3JTYO",
	"details": "Y_mLqvFmzyAxzi"
};
export default ___CSS_LOADER_EXPORT___;
